import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { useServices } from "@/hooks/useContent";

export const ServicesBento = () => {
  const SERVICES = useServices();
  return (
    <section id="services" data-testid="services-section" className="py-24 sm:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#0090D0] font-medium mb-5">What we do</p>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14 sm:mb-20">
            <h2 className="font-serif font-semibold tracking-tight text-[#103080] text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-2xl">
              Everything your business needs, under one roof.
            </h2>
            <p className="text-base text-[#0F172A]/65 max-w-sm leading-relaxed">
              Fixed, tailored fees — you only pay for the level of support you actually need. No surprises, ever.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.slug}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -6 }}
              className={`${s.span} flex`}
            >
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className={`group relative w-full rounded-2xl border border-[#103080]/10 ${s.tint} p-8 sm:p-12 ambient-shadow overflow-hidden`}
              >
                <div className="flex items-start justify-between mb-16 sm:mb-24">
                  <span className={`w-12 h-12 rounded-full bg-white flex items-center justify-center ${s.iconColor} ambient-shadow`}>
                    <s.icon size={22} strokeWidth={1.75} />
                  </span>
                  <ArrowUpRight
                    size={22}
                    className="text-[#103080]/30 transition-all duration-300 group-hover:text-[#0090D0] group-hover:translate-x-1 group-hover:-translate-y-1"
                  />
                </div>
                <h3 className="font-serif font-semibold text-[#103080] text-2xl sm:text-3xl tracking-tight mb-3">
                  {s.title}
                </h3>
                <p className="text-sm sm:text-base text-[#0F172A]/65 leading-relaxed max-w-md">{s.copy}</p>
                <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-[#103080] group-hover:text-[#0090D0] transition-colors duration-300">
                  Find out more <ArrowUpRight size={15} />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
